<template lang="pug">
.dropdown.table-actions-dropdown
  a.settings-link.dropdown-toggle(
    data-toggle="dropdown"
    role="button"
    href="#"
  )
    i.hi.hi-settings
    | Settings
  ul.dropdown-menu.dropdown-menu-right
    li(
      v-for="item in items"
      :key="item.value"
    )
      a(:href="item.value") {{ item.name }}
</template>

<script>
export default {
  name: 'AppSettingsLinkDropdown',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
